<template>
    <div>
        <div
            v-if="!props.isReport"
            class="expansion-item flex"
            @click="showMetadata=!showMetadata"
        >
            <q-icon
                :name="showMetadata ? 'mdi-minus': 'mdi-plus'"
                class="q-mr-sm"
                :style="{width: '20px'}"
            />
            <span>
                Metadata
            </span>
        </div>
        <q-slide-transition>
            <div
                v-if="metadata && showMetadata"
                class="flex-column"
            >
                <GreyTable
                    :table-data="metadata"
                    class="q-mb-sm"
                />
            </div>
        </q-slide-transition>
    </div>
</template>

<script setup>
import GreyTable from '@/components/home/asset-drawer/GreyTable.vue';
import { monthList } from '@/utils/constants.js';
import { computed, ref } from 'vue';

const props = defineProps({
    gaugeData: {
        type: Object,
        default: () => {},
    },
    isReport: {
        type: Boolean,
        default: false,
    },
});

const showMetadata = ref(props.isReport);

const metadata = computed(() => {
    const shownMetadata = [
        {
            header: "Network",
            value: props.gaugeData.gaugeNetwork,
        },
        {
            header: "Gauge ID",
            value: props.gaugeData.originalGaugeId,
        },
    ];
    if (!props.gaugeData.isVirtual) {
        shownMetadata.push(
            {
                header: "Period of Record",
                value: `${props.gaugeData.startYear || 0} - ${props.gaugeData.endYear || 0}`,
            },
            {
                header: "Years of Record",
                value: props.gaugeData.numYears || 0,
            },
            {
                header: "Seasonal",
                value: props.gaugeData.isSeasonal ? `Yes (Operates ${monthList[props.gaugeData.operationStartMonth - 1]} - ${monthList[props.gaugeData.operationEndMonth - 1]})` : 'No',
            },
            {
                header: "Flow Regulated",
                value: props.gaugeData.regulated ? 'Yes' : 'No'
            },
        );
    }
    return shownMetadata;
});

</script>
